export enum ActiveChangeFlag {
  None = 0x0,
  Scene = 0x1,
  Hierarchy = 0x2,
  All = 0x3
}
